import { useEffect, useState } from "react";
import cx from "classnames";
import Button from "../../components/Button/Button";
import { saveCategories, getCategoryText } from "../../reduxSetup/action";
import TYPE from "../../constants/searchType";
import COUNTRIES from "../../constants/countries";
import {
  getSelected,
  getButtonText,
  handleFieldChange,
} from "../../services/filters";
import FindCategoriesForm from "./FindCategoriesForm";
import { formSpotNamesConvertor } from "../../services/formNamesConvertor";
import { getSearchOptions } from "../../services/getSearchOptions";
import PropTypes from "prop-types";
import { TextField } from "../../components/TextField/TextField";
import { Input } from "reactstrap";
import DropDown from "../../containers/DropDown/DropDown";
import { removeEmpty } from "../../services/removeEmpty";
import { propsNamesAdapter } from "../../services/propsNamesAdapter";
import { ModalConsumer } from "../../common/ModalContext";
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown";
import { connect } from "react-redux";
import ModalAdditionResult from "../../components/ModalAdditionResult/ModalAdditionResult";
import styles from "./CategoriesTextsForm.module.scss";

const CategoriesContainerTextsForm = ({
  saveCategories,
  getCategoryText,
  user,
  categories,
}) => {
  const category =
    typeof categories?.allCategories === "string"
      ? null
      : categories?.allCategories[0];
  const [title, setTitle] = useState("");
  const [type, setType] = useState([]);
  const [titleSeo, setTitleSeo] = useState("");
  const [descriptionSeo, setDescriptionSeo] = useState("");
  const [fields, setFields] = useState([]);
  const [text, setText] = useState([{}]);
  const firstText = [...text];
  const lastText = firstText.pop();
  const [findType, setFindType] = useState([]);
  const [findFields, setFindFields] = useState([]);
  const [findCountry, setFindCountry] = useState([]);
  const [findState, setFindState] = useState([]);
  const [country, setCountry] = useState([]);
  const [usState, setUsState] = useState([]);

  const submitCategories = () => {
    text.every((val) => encodeURIComponent(val.description));
    saveCategories({
      title,
      text: removeEmpty(text),
      type,
      country,
      state: country?.[0] === "USA" ? usState : [],
      field: fields,
      titleSeo,
      descriptionSeo,
      author: user.email,
      key: category?.key,
    });
    setTitle("");
    setType([]);
    setTitleSeo("");
    setDescriptionSeo("");
    setFields([]);
    setText([{}]);
    setFindType([]);
    setFindFields([]);
    setFindCountry([]);
    setFindState([]);
    setCountry([]);
    setUsState([]);
  };

  const changeMultipleFieldsObject = (
    itemName,
    itemValue,
    index,
    setState,
    items
  ) => {
    const updatedItems = [...items];

    updatedItems[index][propsNamesAdapter(itemName)] = itemValue;

    if (Object.values(items[index]).every((i) => i === "")) {
      if (items.length === 1) {
        updatedItems[0] = {};
      } else {
        updatedItems.splice(index, 1);
      }
    }

    setState(updatedItems);
  };

  const addFieldObject = (setState, items) => {
    const updatedItems = [...items];
    updatedItems.push({});
    setState(updatedItems);
  };

  useEffect(() => {
    if (!category) return;
    if (category) {
      setTitle(category?.title || "");
      setType(Array.isArray(category?.type) ? category.type : []);
      setTitleSeo(category?.titleSeo || "");
      setDescriptionSeo(category?.descriptionSeo || "");
      setFields(Array.isArray(category?.field) ? category.field : []);
      setText(Array.isArray(category?.text) && category.text.length ? category.text : [{}]);
      setCountry(Array.isArray(category?.country) ? category.country : []);
      setUsState(Array.isArray(category?.state) && category.state.length ? category.state : []);
    }
  }, [categories]);

  const selectedUsState =
    country?.[0] === "USA" && usState?.[0] && usState[0] !== "all"
      ? usState[0]
      : "";
  const categoryListPath =
    type?.[0] && fields?.[0] && country?.[0]
      ? `/list/${type[0]}/${fields[0]}/${country[0]}${
          selectedUsState ? `/${selectedUsState}` : ""
        }`
      : "";

  return (
    <div className={styles.container}>
      <h2>Add categories text</h2>
      <FindCategoriesForm
        setFindType={setFindType}
        setFindFields={setFindFields}
        setFindCountry={setFindCountry}
        setFindState={setFindState}
        findType={findType}
        findFields={findFields}
        findCountry={findCountry}
        findState={findState}
      />

      <div className={styles.formContainer}>
        <TextField
          placeholder="Title"
          label="Title"
          name="name"
          handleChange={(event) => {
            setTitle(event.target.value);
          }}
          value={title}
        />
        <div className={styles.dropDownDesktop}>
          <p className={styles.fieldLabel}>Type*</p>
          <DropDown
            name="type"
            className={styles.autocomplete}
            onChange={(value) => {
              setType([value]);
            }}
            selected={type}
            onClear={() => setType([])}
            options={TYPE.filter((item) => !item.value.includes("New"))}
            buttonText={getButtonText(
              type,
              formSpotNamesConvertor("type"),
              "type"
            )}
          />
        </div>
        <div className={styles.dropDownDesktop}>
          <p className={cx(styles.fieldLabel, styles.topMarginField)}>Field*</p>
          <DropDown
            name="fields"
            className={styles.autocomplete}
            onChange={(value) => setFields([value])}
            selected={fields}
            onClear={() => setFields([])}
            options={type && getSearchOptions(type[0])}
            buttonText={getButtonText(fields, "Fileds", type[0])}
          />
        </div>
        <div className={styles.dropDownDesktop}>
          <p className={cx(styles.fieldLabel, styles.topMarginField)}>
            Country*
          </p>
          <DropDown
            name="countries"
            className={styles.autocomplete}
            onChange={(value) => {
              setCountry([value]);
              if (value !== "USA") setUsState([]);
            }}
            selected={country}
            onClear={() => {
              setCountry([]);
              setUsState([]);
            }}
            options={COUNTRIES}
            buttonText={getButtonText(country, "Country", "countries")}
          />
        </div>
        {country?.[0] === "USA" && (
          <div className={styles.dropDownDesktop}>
            <p className={cx(styles.fieldLabel, styles.topMarginField)}>
              State (empty = all USA)
            </p>
            <DropDown
              name="usState"
              className={styles.autocomplete}
              onChange={(value) => setUsState(value === "all" ? [] : [value])}
              selected={usState}
              onClear={() => setUsState([])}
              options={getSearchOptions("states")}
              buttonText={getButtonText(usState, "All USA", "states")}
            />
          </div>
        )}
        <div className={styles.dropDownMobile}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p className={cx(styles.fieldLabel)}>Type*</p>
                <Button
                  onClick={() => {
                    toggleModal("type");
                  }}
                  className={cx(
                    styles.filterButton,
                    type.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {getButtonText(type, "Type", "type")}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>

        <div className={styles.dropDownMobile}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p className={cx(styles.fieldLabel)}>Field*</p>
                <Button
                  onClick={() => {
                    toggleModal("fields");
                  }}
                  className={cx(
                    styles.filterButton,
                    fields.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {fields.length > 0 ? fields[0] : "Fields"}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
        <div className={styles.dropDownMobile}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p className={cx(styles.fieldLabel)}>Country*</p>
                <Button
                  onClick={() => {
                    toggleModal("country");
                  }}
                  className={cx(
                    styles.filterButton,
                    country?.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {getButtonText(country, "Country", "countries")}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
        {country?.[0] === "USA" && (
          <div className={styles.dropDownMobile}>
            <ModalConsumer>
              {({ toggleModal }) => (
                <>
                  <p className={cx(styles.fieldLabel)}>State (empty = all USA)</p>
                  <Button
                    onClick={() => {
                      toggleModal("usState");
                    }}
                    className={cx(
                      styles.filterButton,
                      usState?.length ? styles.labelValue : styles.labelName
                    )}
                  >
                    {getButtonText(usState, "All USA", "states")}
                  </Button>
                </>
              )}
            </ModalConsumer>
          </div>
        )}
        {categoryListPath && (
          <p className={cx(styles.fieldLabel, styles.topMarginField)}>
            This text is only for {categoryListPath}. Type + field + country +
            state each have their own text.
          </p>
        )}
        <div className={styles.multiFields}>
          <h3>Text</h3>

          {firstText?.map((textItem, index) => (
            <div className={styles.fieldContainer} key={index}>
              <div className={styles.fieldLoop}>
                <TextField
                  key={`textTitle ${index}`}
                  placeholder="Text Title"
                  label="Text Title*"
                  name="textTitle"
                  handleChange={(e) => {
                    changeMultipleFieldsObject(
                      e.target.name,
                      e.target.value,
                      index,
                      setText,
                      text
                    );
                  }}
                  value={textItem.title}
                />

                <div className={styles.textareaContainer}>
                  <p className={styles.fieldLabel}>Text Description*</p>
                  <Input
                    className={cx(styles.textarea)}
                    type="textarea"
                    name="textDescription"
                    placeholder="Text Description"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setText,
                        text
                      );
                    }}
                    value={textItem.description}
                  />
                </div>
              </div>
            </div>
          ))}

          <div className={cx(styles.fieldContainer)}>
            <div className={styles.fieldWithButtonTextarea}>
              <TextField
                placeholder="Text title"
                label="Text title*"
                name="textTitle"
                handleChange={(e) => {
                  changeMultipleFieldsObject(
                    e.target.name,
                    e.target.value,
                    text.length - 1,
                    setText,
                    text
                  );
                }}
                value={lastText?.title ?? ""}
              />

              <div className={styles.textareaContainer}>
                <p className={styles.fieldLabel}>Text Description*</p>
                <Input
                  className={cx(styles.textarea)}
                  type="textarea"
                  name="textDescription"
                  placeholder="Text Description"
                  onChange={(e) => {
                    changeMultipleFieldsObject(
                      e.target.name,
                      e.target.value,
                      text.length - 1,
                      setText,
                      text
                    );
                  }}
                  value={lastText?.description ?? ""}
                />
              </div>
            </div>
            <Button
              className={styles.plusButton}
              onClick={() => addFieldObject(setText, text)}
              disabled={!!lastText && !Object.keys(lastText).length}
            >
              +
            </Button>
          </div>
        </div>
        <TextField
          placeholder="Title Seo"
          label="Title Seo*"
          name="name"
          handleChange={(event) => {
            setTitleSeo(event.target.value);
          }}
          value={titleSeo}
        />
        <TextField
          placeholder="Description Seo"
          label="Description Seo*"
          name="name"
          handleChange={(event) => {
            setDescriptionSeo(event.target.value);
          }}
          value={descriptionSeo}
        />
        <Button
          disabled={!titleSeo || !type || !descriptionSeo || !text.length}
          className={styles.sendButton}
          onClick={() => submitCategories()}
        >
          Add
        </Button>
        <ModalConsumer>
          {({ isOpen, toggleModal, modalId }) => {
            return (
              modalId === "fields" && (
                <ModalWithDropDown
                  onSave={toggleModal}
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  name={modalId}
                  options={getSearchOptions(type[0])}
                  selected={getSelected({
                    modalId,
                    fields,
                  })}
                  onChange={(value) => setFields([value])}
                  onClear={() => setFields([])}
                />
              )
            );
          }}
        </ModalConsumer>
        <ModalConsumer>
          {({ isOpen, toggleModal, modalId }) => {
            return (
              modalId === "type" && (
                <ModalWithDropDown
                  onSave={toggleModal}
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  name={modalId}
                  options={TYPE.filter((item) => !item.value.includes("New"))}
                  selected={getSelected({
                    modalId,
                    type,
                  })}
                  onChange={handleFieldChange.bind({
                    filter: modalId,
                    changeFilter: (value) => setType(value),
                    selected: getSelected({
                      modalId,
                      type,
                    }),
                  })}
                  onClear={() => setType([])}
                />
              )
            );
          }}
        </ModalConsumer>
        <ModalConsumer>
          {({ isOpen, toggleModal, modalId }) => {
            return (
              modalId === "country" && (
                <ModalWithDropDown
                  onSave={toggleModal}
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  name={modalId}
                  options={COUNTRIES}
                  selected={country}
                  onChange={handleFieldChange.bind({
                    filter: "countries",
                    changeFilter: (value) => {
                      setCountry(value);
                      if (!(value?.[0] === "USA")) setUsState([]);
                    },
                    selected: getSelected({
                      modalId: "countries",
                      country,
                    }),
                  })}
                  onClear={() => {
                    setCountry([]);
                    setUsState([]);
                  }}
                />
              )
            );
          }}
        </ModalConsumer>
        <ModalConsumer>
          {({ isOpen, toggleModal, modalId }) => {
            return (
              modalId === "usState" && (
                <ModalWithDropDown
                  onSave={toggleModal}
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  name={modalId}
                  options={getSearchOptions("states")}
                  selected={usState}
                  onChange={handleFieldChange.bind({
                    filter: "usState",
                    changeFilter: (value) =>
                      setUsState(value?.[0] === "all" ? [] : value),
                    selected: usState,
                  })}
                  onClear={() => setUsState([])}
                />
              )
            );
          }}
        </ModalConsumer>

        <ModalConsumer>
          {({ isOpen, toggleModal, modalId }) => {
            return (
              <>
                {modalId === "organization" && (
                  <ModalAdditionResult
                    toggleModal={toggleModal}
                    isOpen={isOpen}
                    content="You've added a spot"
                  />
                )}

                {modalId === "wrongAddress" && (
                  <ModalAdditionResult
                    toggleModal={toggleModal}
                    isOpen={isOpen}
                    content="Address is wrong. Please change the address and try again"
                  />
                )}
              </>
            );
          }}
        </ModalConsumer>
      </div>
    </div>
  );
};
CategoriesContainerTextsForm.propTypes = {
  saveCategories: PropTypes.func,
  getCategoryText: PropTypes.func,
};

const mapStateToProps = ({ user, categories }) => {
  return {
    user,
    categories,
  };
};

const mapDispatchToProps = {
  saveCategories,
  getCategoryText,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesContainerTextsForm);
